// src/components/Loader2.js
import React from "react";

const Loader2 = ({ text = "Loading..." }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200">
      <div className="flex flex-col items-center">
        <svg
          className="animate-spin h-8 w-8 text-indigo-500 dark:text-indigo-400 mb-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
        <span className="text-sm font-medium">{text}</span>
      </div>
    </div>
  );
};

export default Loader2;